import { graphql, useStaticQuery } from 'gatsby';
import { BlogPageQuery, BlogPagePreview } from './blogQueries';

export const useResearch = (): BlogPagePreview[] => {
    const researchPagePreviews: BlogPageQuery = useStaticQuery(graphql`
        {
            allKontentItemLayoutMasterPage(
                filter: {
                    elements: {
                        page_type: {
                            value: {
                                elemMatch: { codename: { eq: "case_study" } }
                            }
                        }
                    }
                    system: { workflow_step: { ne: "archived" } }
                }
                sort: { system: { last_modified: DESC } }
            ) {
                nodes {
                    ...blogPagePreview
                }
            }
        }
    `);
    // i had updated to support in pagetype before case_study if anything breaks update the pagetype to support
    return researchPagePreviews.allKontentItemLayoutMasterPage.nodes;
};
